import { Button, ButtonType } from '@checkmarx/cx-ui';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { UserEditDialogForm, UserEditFormMode } from '../../../services/enums/users';
import InviteUsersDialog from '../InviteUsersDialog';

@inject('translationsStore', 'inviteUserStore', 'authenticationProvidersStore') @observer
export default class InviteUsersButtonContainer extends Component {
    
    state = {
        showAddUserModal: false
    };

    closeAddUserModal = (e) => {

        this.setState({ 
            showAddUserModal: false
        });

        const applicationProvider = this.props.authenticationProvidersStore.getApplicationAuthenticationProvider();     
                      
        this.props.inviteUserStore.setUserEditDialogForm(UserEditDialogForm.add);
        this.props.inviteUserStore.reset();
    }
    
    openAddUserModal = (e) => {
        
        const applicationProvider = this.props.authenticationProvidersStore.getApplicationAuthenticationProvider();     
                      
        this.setState({ 
            showAddUserModal: true
        });
    }

    switchToAddUserFrom = () => {

        this.props.inviteUserStore.setUserEditDialogForm(UserEditDialogForm.add);
    }

    switchToImportLDAPForm = () => {

        this.props.inviteUserStore.setUserEditDialogForm(UserEditDialogForm.importFromDirectory);
    }

    render() {

        return (
            [
                <Button
                   key={1}
                   style={{
                       height: 26,
                       lineHeight: '26px',
                       marginRight: '37px'
                   }}
                   onClick={this.openAddUserModal}
                   text={this.props.addUserText}
                />,
                <InviteUsersDialog
                   key={2}
                   openAddUserModal={this.openAddUserModal}
                   closeAddUserModal={this.closeAddUserModal}
                   switchToAddUserFrom={this.switchToAddUserFrom}
                   switchToImportLDAPForm={this.switchToImportLDAPForm}
                   show={this.state.showAddUserModal}
                   mode={this.props.inviteUserStore.userEditDialogForm}
                />
            ]
        );
    }
}